var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9428 10.0003L14.4714 6.47166C14.7321 6.211 14.7321 5.78966 14.4714 5.529C14.2108 5.26833 13.7894 5.26833 13.5288 5.529L10.0001 9.05766L6.47142 5.529C6.21075 5.26833 5.78942 5.26833 5.52875 5.529C5.26809 5.78966 5.26809 6.211 5.52875 6.47166L9.05742 10.0003L5.52875 13.529C5.26809 13.7897 5.26809 14.211 5.52875 14.4717C5.65875 14.6017 5.82942 14.667 6.00009 14.667C6.17075 14.667 6.34142 14.6017 6.47142 14.4717L10.0001 10.943L13.5288 14.4717C13.6588 14.6017 13.8294 14.667 14.0001 14.667C14.1708 14.667 14.3414 14.6017 14.4714 14.4717C14.7321 14.211 14.7321 13.7897 14.4714 13.529L10.9428 10.0003Z",
    fill: "#616774"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    rx: 9.5,
    stroke: "#DCDCDC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/CloseIcon.cdc15a12.svg";
export { ForwardRef as ReactComponent };